// ChatBox.tsx
import classNames from "classnames";
import React, { useCallback, useEffect, useState } from "react";
import styles from "./styles.module.css";
import { SendIcon } from "../../atoms/icons/sendIcon";
import {
  // addCreator,
  getCreators,
} from "src/api/creators";
import {
  getFBConversationList,
  getFBConversationMessages,
} from "src/api/conversations";
import { Refresh } from "../../atoms/icons/refresh";
import { sendMessage } from "src/utils/FbApiHandlers";
import { toast } from "react-toastify";
// import { getPages } from "src/api/pages";
import moment from "moment";
// import io from "socket.io-client";

const socket = new WebSocket("wss://user.api.heyseva.com");

// interface Message {
//   id: number;
//   message: string;
//   sender: string;
//   messageType: string;
//   media?: string;
//   messageCreatedAt: string;
//   from?: {
//     id: string;
//     username: string;
//     creatorId: string | null;
//     pageId: string | null;
//   };
//   to?: {
//     id: string;
//     username: string;
//     creatorId: string | null;
//     pageId: string | null;
//   };
// }

interface NewMessage {
  isSeen?: boolean;
  story?: {
    mention: {
      link: string;
    };
  };
  message: string;
  created_time: string;
  from: {
    username: string;
    id: string;
  };
  to: {
    data: [
      {
        username: string;
        id: string;
      }
    ];
  };
  id: string;
  attachments?: {
    data: [
      {
        image_data: {
          width: number;
          height: number;
          max_width: number;
          max_height: number;
          url: string;
          preview_url: string;
        };
      }
    ];
  };
}

interface AppUser {
  _id: string;
  name: string;
  username: string;
  socialId: string;
  messageScopeId: string;
  igId: string;
  profilePic: string;
  followers: number;
}

type Props = {
  selectedUserName: string;
  selectPage: any;
  message: string;
};

export const ChatBox: React.FC<Props> = ({
  selectedUserName,
  selectPage,
  message = "",
}) => {
  const [refreshLoading, setRefreshLoading] = useState(false);
  const [chatPage, setChatPage] = useState(0);
  const CHAT_PAGE_SIZE = 10;
  // const [selectPage, setSelectPage] = useState({
  //   _id: "",
  //   name: "",
  //   pageId: "",
  //   accessToken: "",
  //   instagramId: "",
  //   password: "",
  //   username: "",
  //   createdAt: "",
  //   updatedAt: "",
  // });
  const [users, setUsers] = useState<AppUser[]>([]);
  const [selectedUser, setSelectedUser] = useState<AppUser>();

  const getPageConversation = (selectedUser: AppUser) => {
    if (!selectedUser) return;
    setRefreshLoading(true);
    // Two-step: light list (no nested messages → no "too much data"), then
    // hydrate messages for the one matching conversation.
    getFBConversationList({
      token: selectPage.accessToken,
      pageId: selectPage.pageId,
    })
      .then(async (response: any) => {
        const conv = response?.data?.find(
          (x: any) =>
            x.name?.trim().toLowerCase() ===
            selectedUser?.name?.trim().toLowerCase()
        );
        // No matching thread — clear the pane instead of crashing on .messages.
        if (!conv?.id) {
          setMessages([]);
          return;
        }

        const msgRes: any = await getFBConversationMessages({
          token: selectPage.accessToken,
          conversationId: conv.id,
        });
        const res: any = msgRes?.data || [];
        setMessages(res.reverse());

        if (res.length > 0 && selectedUser.messageScopeId.length === 0) {
          if (res[0].from.username === selectedUser.username) {
            selectedUser.messageScopeId = res[0].from.id;
          } else {
            selectedUser.messageScopeId = res[0].to.data[0].id;
          }
          setSelectedUser({ ...selectedUser });
        }

        if (res.length > 4) {
          setTimeout(() => {
            const chatBoxView = document.getElementById("chatBoxView");
            if (chatBoxView) {
              chatBoxView.scrollTop = chatBoxView.scrollHeight;
            }
          }, 500);
        }
      })
      .catch((err: any) => {
        console.log("getPageConversation----", err?.message || err);
        toast.error("Failed to load conversation");
      })
      .finally(() => {
        setRefreshLoading(false);
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getPageCreators = () => {
    setRefreshLoading(true);
    getCreators()
      .then((res: any) => {
        if (res) {
          setUsers(res.data.filter((x: any) => x.username?.length > 0));
          if (selectedUserName) {
            const matchingCreator = res.data.find(
              (x: any) => x.username === selectedUserName
            );
            if (matchingCreator) {
              setSelectedUser(matchingCreator);
              setTimeout(() => {
                getPageConversation(matchingCreator);
              }, 1000);
              // getPageConversation();
            }
          }
        }
      })
      .finally(() => {
        setRefreshLoading(false);
      });
  };

  useEffect(() => {
    if (!selectedUser?._id) {
      getPageCreators();
      // getPages().then((res: any) => {
      //   if (res) {
      //     setSelectPage(res.data[0]);
      //   }
      // });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUser]);

  const [messageInput, setMessageInput] = useState<string>(message ?? "");
  const [messages, setMessages] = useState<NewMessage[]>([]);

  const handleUserClick = async (user: AppUser) => {
    await setSelectedUser(user);
    setTimeout(() => {
      getPageConversation(user);
    }, 1000);
  };

  const handleSendMessage = () => {
    // Send the message to your backend or update state as needed
    if (messageInput.trim().length > 0) {
      setMessageInput("");
      sendMessage({
        page_id: selectPage._id,
        pageId: selectPage.pageId,
        to:
          users.find((x) => x._id === selectedUser?._id)?.messageScopeId || "",
        username: getUserName(selectedUser?._id || "") || "",
        pageName: selectPage.username,
        message: messageInput,
        token: selectPage.accessToken,
        callback: (status) => {
          if (status) {
            getPageConversation(selectedUser as AppUser);
            toast.success("Message sent successfully");
          } else {
            toast.error("Message sending failed, please authenticate again");
          }
        },
      });
    }
  };

  const getUserName = useCallback(
    (creatorId: string) => {
      return users.find((x) => x._id === creatorId)?.username;
    },
    [users]
  );

  useEffect(() => {
    socket.onopen = () => {
      console.log("Connected to WebSocket server");
    };

    socket.onmessage = (event) => {
      const message = event.data;
      console.log("Message from server:", message);
      setMessages((prevMessages) => [...prevMessages, message]);
    };

    socket.onclose = () => {
      console.log("Disconnected from WebSocket server");
    };

    socket.onerror = (error) => {
      console.error(`WebSocket error: ${error}`);
    };

    // return () => {
    //   socket.close();
    // };
  }, [messages]);

  return (
    <div className={classNames("flex", styles.container)}>
      <div
        className={classNames(
          "w-[240px] shrink-0 flex flex-col overflow-x-hidden",
          styles.sideMenu
        )}
      >
        <div className="flex items-center justify-between border-b pr-2 min-w-0">
          <div className="flex items-center min-w-0">
            <h2 className={classNames("p-4 truncate", styles.sideMenuTitle)}>
              Conversations
            </h2>
            <p className={styles.sideMenuBadge}>{users.length}</p>
          </div>
          <button
            title="Reload conversations"
            className={classNames("shrink-0", styles.refresh, {
              [styles.loading]: refreshLoading,
            })}
            onClick={() => {
              setChatPage(0);
              getPageCreators();
              if (selectedUser) getPageConversation(selectedUser);
            }}
          >
            <Refresh className={styles.icon} />
          </button>
        </div>
        <ul className="flex-1 overflow-y-auto overflow-x-hidden min-w-0">
          {/* copy before reversing — .reverse() mutates in place and would
              re-order the list on every render — then page it */}
          {[...users]
            .reverse()
            .slice(chatPage * CHAT_PAGE_SIZE, (chatPage + 1) * CHAT_PAGE_SIZE)
            .map((user, index) => (
              <li
                key={user._id || index}
                className={classNames(
                  `cursor-pointer px-3 py-3 border-b text-sm truncate`,
                  styles.userName,
                  {
                    [styles.selectedUser]: selectedUser?._id === user._id,
                  }
                )}
                onClick={() => handleUserClick(user)}
              >
                {user.username}
              </li>
            ))}
        </ul>
        {users.length > CHAT_PAGE_SIZE && (
          <div className="flex items-center justify-between p-2 border-t text-xs">
            <button
              disabled={chatPage === 0}
              onClick={() => setChatPage((p) => Math.max(0, p - 1))}
              className="px-2 py-1 disabled:opacity-40"
            >
              ‹ Prev
            </button>
            <span className="text-gray-500">
              {chatPage + 1}/{Math.ceil(users.length / CHAT_PAGE_SIZE)}
            </span>
            <button
              disabled={(chatPage + 1) * CHAT_PAGE_SIZE >= users.length}
              onClick={() => setChatPage((p) => p + 1)}
              className="px-2 py-1 disabled:opacity-40"
            >
              Next ›
            </button>
          </div>
        )}
      </div>

      <div className="flex-1 min-w-0 bg-white">
        {selectedUser && (
          <div
            className={classNames(
              "flex items-center justify-between p-4 mb-4",
              styles.chatBoxHeader
            )}
          >
            <h2 className={styles.chatBoxHeaderTitle}>
              {getUserName(selectedUser._id)}
            </h2>
            <button
              className={classNames(styles.refresh, {
                [styles.loading]: refreshLoading,
              })}
              onClick={() => getPageConversation(selectedUser)}
            >
              <Refresh className={styles.icon} />
            </button>
          </div>
        )}

        <div
          className={classNames(
            "flex flex-col space-y-2 p-4",
            styles.chatBoxView
          )}
          id="chatBoxView"
        >
          {!selectedUser && (
            <div className="flex items-center justify-center h-full">
              <p className="text-gray-400">
                Select a conversation to start chatting
              </p>
            </div>
          )}
          {selectedUser && messages.length === 0 && (
            <div className="flex items-center justify-center h-full">
              <p className="text-gray-400">No messages yet</p>
            </div>
          )}
          {messages.map((msg, i) => (
            <>
              {msg.story?.mention?.link?.length !== undefined ||
              msg?.attachments?.data?.length ||
              msg?.message?.length !== 0 ? (
                <div
                  key={i}
                  className={classNames({
                    "self-start": msg.from?.id === selectedUser?.messageScopeId,
                    "self-end": msg.from?.id !== selectedUser?.messageScopeId,
                  })}
                >
                  {msg.from?.id === selectedUser?.messageScopeId && (
                    <>
                      <p className={styles.chatBoxUserName}>
                        {getUserName(selectedUser?._id || "")}
                        <span className={styles.chatBoxUserDate}>
                          {moment(msg.created_time).format("DD/MM/YY hh:mm:a")}
                        </span>
                      </p>
                    </>
                  )}
                  {msg.from?.id !== selectedUser?.messageScopeId && (
                    <p className={styles.chatBoxUserName}>
                      You
                      <span className={styles.chatBoxUserDate}>
                        {moment(msg.created_time).format("DD/MM/YY hh:mm:a")}
                      </span>
                    </p>
                  )}
                  <div
                    key={msg.id}
                    className={classNames("py-2 px-4 rounded-full max-w-md", {
                      [styles.primaryChatBox]:
                        msg.from?.id === selectedUser?.messageScopeId,
                      [styles.secondaryChatBox]:
                        msg.from?.id !== selectedUser?.messageScopeId,
                    })}
                  >
                    {msg.story?.mention?.link.length !== undefined ||
                    msg?.attachments?.data ? (
                      <a
                        href={
                          msg.story?.mention?.link ||
                          msg?.attachments?.data?.at(0)?.image_data?.url
                        }
                        target="_blank"
                        rel="noreferrer"
                        title={"media"}
                      >
                        {msg.story?.mention.link ? (
                          <img
                            title={"Story"}
                            src={msg.story?.mention.link}
                            width={msg.story?.mention.link ? 30 : 100}
                            height={msg.story?.mention.link ? 80 : 250}
                            alt={"media"}
                            onError={(e) => {
                              // Story/media CDN links expire — hide broken ones.
                              (e.currentTarget as HTMLImageElement).style.display =
                                "none";
                            }}
                          />
                        ) : null}
                        {msg?.attachments?.data?.at(0)?.image_data
                          ?.preview_url ? (
                          <img
                            title={"Image"}
                            src={
                              msg?.attachments?.data?.at(0)?.image_data
                                ?.preview_url
                            }
                            width={msg.story?.mention.link ? 30 : 100}
                            height={msg.story?.mention.link ? 80 : 250}
                            alt={"media"}
                            onError={(e) => {
                              (e.currentTarget as HTMLImageElement).style.display =
                                "none";
                            }}
                          />
                        ) : null}
                        {msg.story?.mention.link.length === 0
                          ? "Mentioned you in a story"
                          : ""}
                        {msg.message ? msg.message : ""}
                      </a>
                    ) : (
                      msg.message
                    )}
                  </div>
                  {msg.from?.id !== selectedUser?.messageScopeId &&
                    !!msg.isSeen && (
                      <span className={styles.seenText}>Seen</span>
                    )}
                </div>
              ) : null}
            </>
          ))}
        </div>

        {/* Message Input — only once a conversation is picked. Without the
            selectedUser guard this rendered on an empty pane, because
            `undefined !== 0` is true. */}
        {!selectedUser ? null : selectedUser.messageScopeId?.length !== 0 ? (
          <div
            className={classNames(
              "flex items-center p-4 mt-4",
              styles.chatBoxFooter
            )}
          >
            <input
              type="text"
              placeholder="Message"
              value={messageInput}
              onChange={(e) => setMessageInput(e.target.value)}
              className={classNames(
                "flex-1 p-2 mr-2 border",
                styles.sendMessageInput
              )}
            />
            <button
              className={classNames("px-4 py-2 text-white", styles.sendButton)}
              onClick={handleSendMessage}
            >
              <SendIcon />
            </button>
          </div>
        ) : (
          <div>
            <p
              style={{
                textAlign: "center",
                color: "gray",
                padding: "10px",
                borderTop: "1px solid #80808059",
              }}
            >
              Cannot send message to this user, initiate message from the
              instagram app.{" "}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
